import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const LogContext = React.createContext(null);

const { Provider } = LogContext;
export const LogProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        project: null,
        lookUpData: null,
        isRestoringProject: false,
    });

    const getProjectAsync = async (data) => {
        try {
            const getProjectApi = await fetchAuthorized(ApiRoutes.Projects.GetProject({ projectId: data }),
                {
                    method: HttpMethods.GET
                });

            const project = await getProjectApi.json();
            setState({ project, isRestoringProject: false });
        }

        catch (ex) {
            console.error(ex);
            console.error(ex.details);
        }
    }

    const getLookupDataAsync = async () => {
        try {
            const getLookupDataApi = await fetchAuthorized(ApiRoutes.Data.GetLookupData({ includeDeleted: true }),
                {
                    method: HttpMethods.GET
                });

            const lookUpData = await getLookupDataApi.json();
            setState({ lookUpData });
        }

        catch (ex) {
            console.error(ex);
            console.error(ex.details);
        }
    }

    const restoreProjectAsync = async (projectChangeId) => {
        try {
            setState({ isRestoringProject: true });
            const restoreProjectsApi = await fetchAuthorized(ApiRoutes.Projects.RestoreProject({ projectChangeId: projectChangeId }),
                {
                    method: HttpMethods.POST,
                    body: JSON.stringify({}),
                    collectErrorDetails: true
                });

            await restoreProjectsApi.json();
            return true;
        }

        catch (ex) {
            setState({ isRestoringProject: false });
            console.error(ex);
            console.error(ex.details);
        }
    }

    return (
        <Provider value={{
            state,
            getProjectAsync,
            getLookupDataAsync,
            restoreProjectAsync
        }}>
            {props.children}
        </Provider>
    );
}